<template>
	<div class="container">
		<div class="tabs" aria-label="当前页面用于预约志愿者答疑，顶部是选项卡区，包括预约申请和申请记录查询两个部分，在预约申请中，您可以填写表单并点击提交，我们将收到您的预约申请；在预约记录查询中，您可以查看到您过往的申请记录，每一条记录右侧都有一个查看按钮，点击后即可对记录进行编辑和删除操作。" tabindex="0">
			<div
				class="tab"
				:class="{ active: activeTab === 'appointment' }"
				@click="handleTab('appointment')"
				@keydown.enter="handleTab('appointment')"
				tabindex="0"
				role="tab"
				:aria-label="(activeTab === 'appointment' ? '已选中 ' : '') + '预约申请'"
			>
				预约申请
			</div>
			<div
				ref="startpoint1"
				class="tab"
				:class="{ active: activeTab === 'record' }"
				@click="handleTab('record')"
				@keydown.enter="handleTab('record')"
				tabindex="0"
				role="tab"
				:aria-label="(activeTab === 'record' ? '已选中 ' : '') + '预约记录查询'"
			>
				预约记录查询
			</div>
		</div>

		<form @submit.prevent="postAppointment" class="form" v-if="activeTab === 'appointment'">
			<div class="form-group">
				<label for="name">姓名：</label>
				<input type="text" id="name" class="input-field" v-model.trim="formData.name" />
			</div>
			<div class="form-group">
				<label for="expectedTime">期望时间：</label>
				<input type="text" id="expectedTime" class="input-field" v-model.trim="formData.expectedTime" />
			</div>
			<div class="form-group">
				<label for="problem">问题描述：</label>
				<textarea id="problem" class="textarea-field" v-model.trim="formData.problem"></textarea>
			</div>
			<div class="form-group">
				<label for="contact">手机号/微信号：</label>
				<input type="text" id="contact" class="input-field" v-model.trim="formData.contact" />
			</div>

			<div class="button-container">
				<button type="submit" tabindex="0" class="submit-button">提交</button>
			</div>
		</form>

		<div v-if="activeTab === 'record'" class="content" style="display: flex; flex-direction: column; width:80%;">
			<div class="recordItem" 
				style="display: flex; flex-direction: column; justify-content: center; padding: 8px 12px; width: 100%; height: 60px; background-color: rgb(200, 200, 240); margin-top: 10px; position: relative;" 
				v-for="(record, index) in appointments" 
				:key="index">
				<div class="recordTitle"
					style="color: black; font-size: 18px; font-weight: bold; margin-bottom: 2px;"
					tabindex="0"
				>
					申请记录
				</div>
				<div class="recordTime" tabindex="0" 
					style="font-size: 14px; color: rgb(80, 80, 80);">
					{{ record["modifyAt"] }}
				</div>
				<button class="viewRecord" 
					style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); padding: 4px 10px;"
					@click="showAppointment(index)"
					tabindex="0"
				>查看</button>
			</div>
		</div>

		<!-- 通用提示框 -->
		<div class="modal" v-if="showMessageModal" style="z-index: 2;">
			<div class="message-modal-box">
				<p class="message-modal-content" tabindex="0">{{ modalMessage }}</p>
				<button
					class="message-modal-button"
					@click="closeMessageModal"
					ref="modalButton"
				>知道了</button>
			</div>
		</div>

		<div v-if="showInfoModal" class="modal" style="z-index: 1;">
			<div class="info-modal-box">
				<button
					ref="startpoint2"
					aria-label="关闭申请记录展示窗口"
					style="position: absolute; top: 10px; left: 10px; font-size: 20px; background: none; border: none; cursor: pointer;"
					@click="closeInfoModal()"
				>×</button>

				<button
					style="position: absolute; top: 10px; right: 80px; width: 60px; height: 30px; background-color: blue; color: white; border: none; cursor: pointer; border-radius: 5px;"
					@click="changeEditingMode()"
				>{{editingAppointment ? '取消' : '编辑'}}</button>

					<button
					style="position: absolute; top: 10px; right: 10px; width: 60px; height: 30px; background-color: gray; color: white; border: none; cursor: pointer; border-radius: 5px;"
					@click="deleteAppointment()"
				>删除</button>

				<div class="form" >
					<div class="form-group">
						<label for="name">姓名：</label>
						<input type="text" :readonly="!editingAppointment" id="name" class="input-field" v-model.trim="formData.name" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 5px;" />
					</div>
					<div class="form-group">
						<label for="expectedTime">期望时间：</label>
						<input type="text" :readonly="!editingAppointment" id="expectedTime" class="input-field" v-model.trim="formData.expectedTime" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 5px;" />
					</div>
					<div class="form-group">
						<label for="problem">问题描述：</label>
						<textarea id="problem" class="textarea-field" :readonly="!editingAppointment" v-model.trim="formData.problem" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 5px;"></textarea>
					</div>
					<div class="form-group">
						<label for="contact">手机号/微信号：</label>
						<input type="text" :readonly="!editingAppointment" id="contact" class="input-field" v-model.trim="formData.contact" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 5px;" />
					</div>
				</div>

				<button
					v-if="editingAppointment"
					style="width: 100px; padding: 12px; background-color: #003366; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;"
					@click="saveAppointment()"
				>保存</button>
			</div>
		</div>

	</div>
</template>

<script>
import { baseUrl, postAppointmentUrl, checkAppointmentsUrl, updateAppointmentUrl, deleteAppointmentUrl } from '@/constants/urls.js';
import axios from 'axios';

export default {
	data() {
		return {
			activeTab: 'appointment',
			baseUrl: baseUrl,
			postAppointmentUrl: postAppointmentUrl,
			checkAppointmentsUrl: checkAppointmentsUrl,
			updateAppointmentUrl: updateAppointmentUrl,
			deleteAppointmentUrl: deleteAppointmentUrl,
			formData: {
				id: null,
				name: '',
				expectedTime: '',
				problem: '',
				contact: ''
			},
			appointments: [],
			editingAppointment: false,
			showMessageModal: false,
			modalMessage: '',
			showInfoModal: false,
		};
	},
	created() {
		this.getAppointments();
	},
	methods: {
		getAppointments() {
			axios.get(`${this.baseUrl}${this.checkAppointmentsUrl}`).then(response => {
				this.appointments=response.data;
			}).catch(error => {
				alert("发生了错误"+error);
			});
		},
		postAppointment(){
			if (!this.validateForm()){
				return;
			}
			axios.post(`${baseUrl}${postAppointmentUrl}`, this.formData).then(response => {
				if (response.status == 200) {
					this.openMessageModal("提交成功！");
					this.getAppointments();
				} else {
					this.openMessageModal("提交失败");
				}
			}).catch(error => {
				this.openMessageModal("发生了错误："+error);
			});
		},
		handleTab(tab) {
			this.activeTab = tab;
		},
		validateForm() {
			const fields = [
				{ key: 'name', label: '姓名' },
				{ key: 'expectedTime', label: '期望时间' },
				{ key: 'problem', label: '问题描述' },
				{ key: 'contact', label: '手机号/微信号' }
			];

			for (let field of fields) {
				if (!this.formData[field.key]) {
					this.openMessageModal(`${field.label}不能为空`);
					return false;
				}
			}

			return true;
		},
		showAppointment(index){
			const appointment=this.appointments[index];
			this.formData.id=appointment.id;
			this.formData.name=appointment.name;
			this.formData.expectedTime=appointment.expectedTime;
			this.formData.problem=appointment.problem;
			this.formData.contact=appointment.contact;
			this.showInfoModal=true;
			this.$nextTick(() => this.$refs.startpoint2.focus());
		},
		closeInfoModal() {
			this.editingAppointment=false;
			this.showInfoModal=false;
			this.clearForm();
			this.$nextTick(() => this.$refs.startpoint1.focus());
		},
		clearForm(){
			this.formData.id=null;
			this.formData.name='';
			this.formData.expectedTime='';
			this.formData.problem='';
			this.formData.contact='';
		},
		changeEditingMode(){
			this.editingAppointment=!this.editingAppointment;
			if (this.editingAppointment){
				const inputField=document.querySelector(".input-field");
				inputField.focus();
			}
		},
		deleteAppointment(){
			axios.get(`${baseUrl}${deleteAppointmentUrl}`, {params:{id: this.formData.id}}).then(response => {
				this.closeInfoModal();
				if (response.status == 200){
					this.openMessageModal("删除成功！");
				} else {
					this.openMessageModal("删除失败");
				}
			}).catch(error => {
				this.openMessageModal("发生了错误："+error);
			});
		},
		saveAppointment(){
			if (!this.validateForm()){
				return;
			}
			axios.post(`${baseUrl}${updateAppointmentUrl}`, this.formData).then(response => {
				if (response.status == 200) {
					this.closeInfoModal();
					this.openMessageModal("保存成功！");
					this.getAppointments();
				} else {
					this.openMessageModal("保存失败");
				}
			}).catch(error =>{
				this.openMessageModal("发生了错误"+error);
			});
		},
		openMessageModal(content){
			this.modalMessage=content;
			this.showMessageModal=true;
			this.$nextTick(() => {
				const messageModalContent=document.querySelector(".message-modal-content");
				messageModalContent.focus();
			});
		},
		closeMessageModal() {
			this.showMessageModal = false;
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 50%;
	margin: auto;
}

.tabs {
	display: flex;
	flex-direction: row;
	width: 70%;
	height: 40px;
	margin-top: 10vh;
}

.tab {
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	text-align: center;
	padding: 10px;
	border: 1px solid #ccc;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.active {
	background: linear-gradient(to bottom, rgb(100, 255, 100), rgb(204, 255, 204));
	color: #006400;
	font-weight: bold;
}

.form {
	width: 600px;
	margin-top: 60px;
}

.form-group {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}

label {
	width: 40%;
	text-align: right;
	margin-right: 10px;
	font-size: 16px;
}

.input-field,
.textarea-field {
	flex: 1;
	width: 100%;
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
}

.textarea-field {
	height: 100px;
	resize: vertical;
}

.button-container {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.submit-button {
	margin-top: 20px;
	width: 30%;
	height: 50px;
	justify-content: center;
	background: linear-gradient(to bottom, rgb(0, 180, 0), rgb(0, 255, 0));
	border: none;
	border-radius: 10%;
	cursor: pointer;
}

.submit-button:hover {
	background-color: #218838;
}

.modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

.message-modal-box {
	background: white;
	padding: 20px;
	border-radius: 10px;
	text-align: center;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	width: 300px;
	outline: none;
}

.message-modal-button {
	margin-top: 20px;
	padding: 10px 20px;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	font-size: 16px;
}

.modal-button:hover {
	background-color: #0056b3;
}

.info-modal-box{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	background-color: white;
	width: 50%;
	height: 600px;
}

@media (max-width: 500px){
	.container {
		width:100%;
	}

	.tabs {
		width: 80%;
		margin-top: 15vh;
	}

	.form {
		width: 90%;
	}

	.form-group {
		margin-bottom: 5px;
	}

	.info-modal-box {
		width:90%;
		height: 400px;
	}

	.info-modal-box .form {
		margin-top: 50px;
	}
}
</style>
